import { Chart as ChartJS } from 'chart.js'
import { ChartLabels, MinMaxData } from 'components/charts/types'
import { formatAmount } from 'utils/format'
import { CoreAnnotationOptions } from 'chartjs-plugin-annotation'

export const getPriceHistoryChartOptions = (
  labels: ChartLabels,
  handleResize: (chart: ChartJS, labels: ChartLabels) => void,
  minMax: MinMaxData,
  alternatingBackground: CoreAnnotationOptions,
  isMobile?: boolean
) => {
  return {
    responsive: true,
    aspectRatio: isMobile ? 3 : 5,
    onResize: (chart: ChartJS) => {
      if (chart?.boxes?.length) {
        handleResize(chart, labels)
      }
    },
    interaction: {
      mode: 'nearest',
      intersect: false
    },
    borderWidth: 2.5,
    pointBorderWidth: 0,
    pointRadius: 0,
    pointHoverRadius: 5,
    scales: {
      y: {
        suggestedMin: minMax?.minDataValue,
        suggestedMax: minMax.maxDataValue,
        ticks: {
          stepSize: 0.01,
          font: {
            family: "'Commuters Sans', sans-serif",
            size: 10
          },
          padding: 5,
          callback: (value: number) => '€ ' + formatAmount(value)
        },
        grid: {
          drawBorder: false,
          drawTicks: false,
          color: '#DDDBE1'
        }
      },
      x: {
        grid: {
          lineWidth: 0
        },
        ticks: {
          font: {
            family: "'Commuters Sans', sans-serif",
            size: 10
          },
          minRotation: 0,
          maxRotation: 0
        }
      }
    },
    plugins: {
      annotation: {
        common: {
          drawTime: 'beforeDraw'
        },
        annotations: {
          ...alternatingBackground
        }
      }
    }
  }
}
